import { Col, Row, Modal, Button, Form, Select } from "antd";
import { IoIosArrowRoundBack } from "react-icons/io";
import { TiArrowSortedDown } from "react-icons/ti";
import { useNavigate, useParams } from "react-router-dom";
import { checkInCity, extractDate } from "../../config/helpers";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Get } from "../../config/api/get";
import { Post } from "../../config/api";
import { BOOKING, FARE, RATES, UPLOADS_URL, ADMIN } from "../../config/constants/api";
import Table from "react-bootstrap/Table";
import "bootstrap/dist/css/bootstrap.min.css";
import swal from "sweetalert";

const ReportDetails = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [bookingDetails, setBookingDetails] = useState(null);
  const [carDetails, setCarDetails] = useState(null);
  const token = useSelector((state) => state.user.userToken);
  const { id } = useParams();
  const [pricing, setPricing] = useState(null);
  const [latestFares, setLatestFares] = useState(null);
  const [latestRates, setLatestRates] = useState(null);
  const [invoiceModalVisible, setInvoiceModalVisible] = useState(false);
  const [assignChauffeurModalVisible, setAssignChauffeurModalVisible] = useState(false);
  const [chauffeurs, setChauffeurs] = useState([]);
  const [assignLoading, setAssignLoading] = useState(false);
  const [form] = Form.useForm();

  const getUserDetails = () => {
    setLoading(true);
    Get(`${BOOKING.getbooking}${id}`, token)
      .then((response) => {
        setBookingDetails(response?.data?.booking);
        setCarDetails(response?.data?.car);
        setLoading(false);
      })
      .catch((err) => {
        console.log("Error fetching user details", err);
        setLoading(false);
      });
  };
  useEffect(() => {
    getUserDetails();
    // eslint-disable-next-line
  }, []);

  const getHourlyRate = () => {
    if (bookingDetails?.appliedRates?.hourlyRate != null) {
      return bookingDetails.appliedRates.hourlyRate;
    }
    if (latestRates && bookingDetails) {
      let rate = latestRates.find(
        (rate) =>
          rate._id.serviceType === bookingDetails?.serviceType &&
          rate._id.passengerCapacity === bookingDetails?.passengerCapacity
      );
      return rate?.rate;
    }
  };

  const getPerMileRate = () => {
    if (bookingDetails?.appliedRates?.farePerMile != null) {
      return bookingDetails.appliedRates.farePerMile;
    }
    if (latestFares && bookingDetails) {
      let service = latestFares.find(
        (fare) =>
          fare._id.serviceType === bookingDetails?.serviceType &&
          fare._id.passengerCapacity === bookingDetails?.passengerCapacity
      );
      return service?.fare;
    }
  };

  const getBookingFee = () =>
    bookingDetails?.appliedRates?.bookingFee != null
      ? bookingDetails.appliedRates.bookingFee
      : pricing?.bookingFee || 0;

  const getServiceFee = () =>
    bookingDetails?.appliedRates?.serviceFee != null
      ? bookingDetails.appliedRates.serviceFee
      : pricing?.serviceFee || 0;

  // const getRushHoursRate = () => {
  //   if (latestRates) {
  //     let rate = latestRates.find(
  //       (rate) => rate._id.serviceType === bookingDetails?.serviceType
  //     );
  //     return rate?.rate * rate?.rushHourMultiple;
  //   }
  // };

  const getAllLatestFares = () => {
    if (bookingDetails) {
      let data = {};
      if (bookingDetails?.dropoffLocation) {
        data.isDistanceFare = true;
        const checkCity = checkInCity(
          bookingDetails?.pickupLocation,
          bookingDetails?.dropoffLocation
        );
        data.inCity = checkCity;
      }
      Get(FARE.getAllLatestFares, token, data)
        .then((response) => {
          if (response?.status) {
            setLatestFares(response?.data?.latestFares);
            setPricing(response?.data?.pricing);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    }
  };
  const getAllLatestRates = () => {
    if (bookingDetails) {
      let data = {};
      if (bookingDetails?.dropoffLocation) {
        data.isDistanceRate = true; // to fetch distance rate if type is book by distance
        const checkCity = checkInCity(
          bookingDetails?.pickupLocation,
          bookingDetails?.dropoffLocation
        );
        data.inCity = checkCity;
      }
      Get(RATES.getAllLatestRates, token, data)
        .then((response) => {
          if (response?.status) {
            setLatestRates(response?.data);
          }
        })
        .catch((err) => {
          console.log("error", err);
        });
    }
  };
  useEffect(() => {
    getAllLatestFares();
    getAllLatestRates();
    // eslint-disable-next-line
  }, [bookingDetails]);

  const formatDuration = (minutes) => {
    if (minutes < 60) {
      return `${minutes} min`;
    } else {
      const hours = (minutes / 60).toFixed(2); // Keeping two decimal places
      return `${hours} hrs`;
    }
  };

  // const calculateRushHourFee = () => {
  //   if (latestRates && bookingDetails) {
  //     let rate = latestRates.find(
  //       (rate) =>
  //         rate._id.serviceType === bookingDetails?.serviceType &&
  //         parseInt(rate._id.passengerCapacity) ===
  //           bookingDetails?.passengerCapacity
  //     );
  //     let rushHourFee = rate?.rate * rate?.rushHourMultiple - rate?.rate;
  //     return rushHourFee;
  //   }
  // };

  const formatinHours = (minutes) => {
    return minutes / 60;
  };

  const getBookingTypeLabel = () => {
    if (bookingDetails?.type === "PtoP") return "Distance";
    if (bookingDetails?.type === "Hourly") return "Hourly";
    if (bookingDetails?.type === "Subscription") return "Subscription";
    if (bookingDetails?.dropoffLocation) return "Distance";
    return "Hourly";
  };

  const getChauffeursByService = async () => {
    if (!bookingDetails?.serviceType) {
      console.log("❌ No serviceType found in bookingDetails");
      return;
    }
    console.log("🔍 Fetching chauffeurs for serviceType:", bookingDetails?.serviceType);
    Get(ADMIN.getChauffeursByService, token, {
      serviceType: bookingDetails?.serviceType,
    })
      .then((response) => {
        console.log("📦 API Response:", response);
        console.log("📦 Response data:", response?.data);
        console.log("📦 Response docs:", response?.data?.docs);
        if (response?.status) {
          const chauffeursList = response.data?.docs || [];
          console.log("✅ Chauffeurs found:", chauffeursList.length);
          console.log("📋 Chauffeurs data:", chauffeursList);
          if (chauffeursList.length > 0) {
            console.log("👤 First chauffeur sample:", chauffeursList[0]);
          }
          setChauffeurs(chauffeursList);
        } else {
          console.log("❌ API returned status false");
          setChauffeurs([]);
        }
      })
      .catch((err) => {
        console.log("❌ Error fetching chauffeurs:", err);
        console.log("❌ Error response:", err?.response?.data);
        swal("Error", "Failed to fetch chauffeurs", "error");
        setChauffeurs([]);
      });
  };

  const handleAssignChauffeur = (values) => {
    setAssignLoading(true);
    Post(
      `${ADMIN.assignChauffeur}${bookingDetails?._id}`,
      {
        chauffeurId: values.selectedChauffeur,
      },
      token
    )
      .then((response) => {
        if (response?.status) {
          setAssignLoading(false);
          swal("Success", response?.message || "Chauffeur assigned successfully", "success");
          setAssignChauffeurModalVisible(false);
          form.resetFields();
          getUserDetails(); // Refresh booking details
        }
      })
      .catch((err) => {
        setAssignLoading(false);
        console.log("Error assigning chauffeur ", err);
        const message = err?.response?.data?.message || err?.message || "Failed to assign chauffeur";
        swal("Error", message, "error");
      });
  };

  // console.log("bookingDetails", bookingDetails.finalMileage * getPerMileRate());
  return (
    <>
    <Row justify="center">
      <Col md={23} xs={22}>
        {!loading && (
          <div
            className="bg-white rounded-lg sm:py-16 py-8 my-12"
            style={{ boxShadow: "1px 1px 1px 1px rgba(0, 0, 0, 0.05)" }}
          >
            <div className="flex justify-start items-center mx-1 lg:mx-8 mb-4">
              <IoIosArrowRoundBack
                onClick={() => navigate(-1)}
                className="self-center cursor-pointer mr-1 w-[48px] h-[48px] max-sm:w-[24px] max-sm:h-[24px] text-black"
              />
              <h3 className="font-tavi lg:text-3xl text-2xl max-sm:text-lg font-normal text-black">
                Booking Detail
              </h3>
            </div>

            <Row justify="center">
              <Col xs={23}>
                <Row justify="" gutter={[32, 16]} className="mb-6">
                  <Col lg={12} xs={22}>
                    <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-start desktop:p-8 p-3 h-full">
                      <h5 className="w-full text-start mb-16 max-desktop:mb-8 max-sm:mb-4 font-tavi text-xl text-black font-semibold max-lg:text-lg">
                        User Information
                      </h5>
                      <img
                        src={bookingDetails?.user?.image 
                          ? UPLOADS_URL + bookingDetails.user.image 
                          : "/assets/images/avatar.png"}
                        onError={(e) => {
                          e.target.src = "/assets/images/avatar.png";
                        }}
                        style={{
                          marginBottom: "40px",
                          height: "150px",
                          width: "150px",
                          objectFit: "cover",
                          objectPosition: "center",
                          borderRadius: "100%",
                        }}
                        alt="profile"
                      />
                      <h5 className="font-euclid text-md max-sm:text-xs text-black font-bold mb-1">
                        User Name
                      </h5>
                      <p className="font-euclid text-md max-sm:text-xs text-gray-500 font-normal mb-6">
                        {bookingDetails?.user?.firstName}{" "}
                        {bookingDetails?.user?.lastName}
                      </p>
                      <h5 className="font-euclid text-md max-sm:text-xs text-black font-bold mb-1">
                        Email
                      </h5>
                      <p className="font-euclid text-md max-sm:text-xs text-gray-500 font-normal mb-6">
                        {bookingDetails?.user?.email}
                      </p>
                      <h5 className="font-euclid text-md max-sm:text-xs text-black font-bold mb-1">
                        Phone
                      </h5>
                      <p className="font-euclid text-md max-sm:text-xs text-gray-500 font-normal mb-6">
                        {bookingDetails?.user?.phone}
                      </p>
                    </div>
                  </Col>
                  <Col lg={12} xs={22}>
                    <div className="flex flex-col items-center justify-center h-full w-full">
                      <div class="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center desktop:p-6 p-3 mb-8 w-full h-full">
                        <h5 class="w-full text-start mb-4 font-tavi text-xl text-black font-semibold max-desktop:text-lg">
                          Booking Details
                        </h5>
                        <div
                          class="mt-3"
                          style={{
                            display: "flex",
                            gap: "0 50px",
                            flexWrap: "wrap",
                          }}
                        >
                          <div class=" items-start">
                            <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                              Booking ID
                            </h5>
                            <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                              #{bookingDetails?._id.slice(-4)}
                            </p>
                          </div>
                          <div class=" items-start">
                            <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                              Service Type
                            </h5>
                            <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                              {bookingDetails?.serviceType} Luxury
                            </p>
                          </div>
                          <div class=" items-start">
                            <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                              Booking Type
                            </h5>
                            <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                              {getBookingTypeLabel()}
                            </p>
                          </div>
                          <div class=" items-start">
                            <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                              From
                            </h5>
                            <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                              {bookingDetails?.pickupLocation?.address}
                            </p>
                          </div>
                          {bookingDetails?.dropoffLocation?.address && (
                            <div class=" items-start">
                              <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                                To
                              </h5>
                              <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                                {bookingDetails?.dropoffLocation?.address}
                              </p>
                            </div>
                          )}
                          <div class=" items-start">
                            <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                              Booking Date
                            </h5>
                            <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                              {extractDate(bookingDetails?.date)}
                            </p>
                          </div>
                          <div class=" items-start">
                            <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                              Booking Duration
                            </h5>
                            <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                              {formatinHours(bookingDetails?.duration) >= 1
                                ? `${formatinHours(
                                    bookingDetails?.duration
                                  )} Hours`
                                : bookingDetails?.duration + " Minutes"}
                            </p>
                          </div>
                          <div class=" items-start">
                            <h5 class="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                              Booking Charges
                            </h5>
                            <p class="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                              $
                              {bookingDetails?.totalCharges != null
                                ? (bookingDetails.totalCharges || 0).toFixed(2)
                                : bookingDetails?.initialCharges != null
                                ? (bookingDetails.initialCharges || 0).toFixed(2)
                                : "0.00"}
                            </p>
                          </div>
                        </div>
                        <div className="mt-4">
                          <button
                            className="uppercase bg-button py-3 px-6 xl:px-16 text-black rounded-lg font-bold text-sm max-desktop:text-[10px] max-md:py-2 max-md:px-4 font-euclid"
                            onClick={() => setInvoiceModalVisible(true)}
                          >
                            View Invoice
                          </button>
                        </div>
                      </div>

                      <div className="bg-[#EBEBEB] rounded-lg flex flex-col items-start justify-center desktop:p-8 p-3 w-full h-full">
                        <h5 className="w-full text-start mb-4 font-tavi text-xl text-black font-semibold max-lg:text-lg">
                          Driver Details
                        </h5>
                        {bookingDetails?.chauffeur ? (
                          <>
                            <div className="flex justify-center items-center mt-3">
                              <div className="flex flex-col items-start desktop:mr-24 sm:mr-6 mr-4">
                                <h5 className="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                                  Driver name
                                </h5>
                                <p className="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                                  {bookingDetails?.chauffeur?.firstName}{" "}
                                  {bookingDetails?.chauffeur?.lastName}
                                </p>
                                <h5 className="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                                  Car Model
                                </h5>
                                <p className="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                                  {carDetails?.model}
                                </p>
                              </div>
                              <div className="flex flex-col items-start desktop:mr-24 sm:mr-8 mr-4">
                                <h5 className="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                                  Car Brand
                                </h5>
                                <p className="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                                  {carDetails?.brand}
                                </p>
                                <h5 className="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                                  Car Number
                                </h5>
                                <p className="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                                  {carDetails?.carNumber}
                                </p>
                              </div>
                              <div className="flex flex-col items-start justify-start h-full">
                                <h5 className="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                                  Car Name
                                </h5>
                                <p className="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                                  {carDetails?.name}
                                </p>
                                <h5 className="font-euclid text-sm max-desktop:text-xs text-black font-bold mb-1">
                                  Car Type
                                </h5>
                                <p className="font-euclid text-sm max-desktop:text-xs text-gray-500 font-normal mb-6">
                                  {carDetails?.serviceType}
                                </p>
                              </div>
                            </div>
                            <button
                              className="uppercase bg-button py-3 px-6 xl:px-16 text-black rounded-lg font-bold text-sm max-desktop:text-[10px] max-md:py-2 max-md:px-4 mr-3 font-euclid"
                              onClick={() =>
                                navigate(
                                  `/driverDetails/${bookingDetails?.chauffeur?._id}`
                                )
                              }
                            >
                              View Chauffeur detail
                            </button>
                          </>
                        ) : (
                          <div className="flex flex-col justify-center items-center mt-3 w-full">
                            <p className="font-euclid text-base text-gray-600 font-normal mb-4">
                              Chauffeur not assigned
                            </p>
                            {bookingDetails?.status === "PAID" ? (
                              <button
                                className="uppercase bg-button py-3 px-6 xl:px-16 text-black rounded-lg font-bold text-sm max-desktop:text-[10px] max-md:py-2 max-md:px-4 font-euclid"
                                onClick={() => {
                                  setAssignChauffeurModalVisible(true);
                                  getChauffeursByService();
                                }}
                              >
                                Assign Chauffeur
                              </button>
                            ) : (
                              <p className="font-euclid text-sm text-gray-500">
                                Assign chauffeur after the booking is paid
                              </p>
                            )}
                          </div>
                        )}
                      </div>

                    </div>
                  </Col>
              
                </Row>
              </Col>
            </Row>
          </div>
        )}
      </Col>
    </Row>

    {/* Invoice Modal */}
    <Modal
      title={
        <h3 className="font-tavi text-2xl text-black">
          Invoice - {bookingDetails?.dropoffLocation
            ? "Distance Service in Manhattan"
            : "Hourly Service in Manhattan"}
        </h3>
      }
      open={invoiceModalVisible}
      onCancel={() => setInvoiceModalVisible(false)}
      footer={[
        <Button
          key="close"
          onClick={() => setInvoiceModalVisible(false)}
          className="bg-button text-black border-none font-bold"
        >
          Close
        </Button>,
      ]}
      width={800}
    >
      <div className="invoice-container" style={{ padding: "20px 0" }}>
        {/* Invoice Header */}
        <div className="mb-6 pb-4 border-b">
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <p className="font-euclid text-sm text-gray-600 mb-1">Booking ID</p>
              <p className="font-euclid text-base font-bold">{bookingDetails?._id}</p>
            </Col>
            <Col span={12} style={{ textAlign: "right" }}>
              <p className="font-euclid text-sm text-gray-600 mb-1">Date</p>
              <p className="font-euclid text-base font-bold">
                {bookingDetails?.createdAt
                  ? extractDate(bookingDetails.createdAt)
                  : "N/A"}
              </p>
            </Col>
          </Row>
        </div>

        {/* Invoice Summary (outside table) */}
        <div className="mb-6 pb-4 border-b">
          <Row gutter={[16, 16]}>
            <Col span={12}>
              <p className="font-euclid text-sm text-gray-600 mb-1">Vehicle Type</p>
              <p className="font-euclid text-base font-bold">
                {bookingDetails?.serviceType} Luxury
              </p>
            </Col>
            <Col span={12} style={{ textAlign: "right" }}>
              <p className="font-euclid text-sm text-gray-600 mb-1">Initial Booking Duration</p>
              <p className="font-euclid text-base font-bold">
                {formatDuration(((bookingDetails?.duration || 0)).toFixed(2))}
              </p>
            </Col>
          </Row>
          <Row gutter={[16, 16]} style={{ marginTop: "16px" }}>
            <Col span={12}>
              <p className="font-euclid text-sm text-gray-600 mb-1">Initial Mileage</p>
              <p className="font-euclid text-base font-bold">
                {bookingDetails?.initialMileage || 0} miles
              </p>
            </Col>
            {bookingDetails?.status === "COMPLETED" && (
              <>
                <Col span={12} style={{ textAlign: "right" }}>
                  <p className="font-euclid text-sm text-gray-600 mb-1">Final Booking Duration</p>
                  <p className="font-euclid text-base font-bold">
                    {formatDuration(((bookingDetails?.finalDuration || 0)).toFixed(2))}
                  </p>
                </Col>
                <Col span={12} style={{ marginTop: "16px" }}>
                  <p className="font-euclid text-sm text-gray-600 mb-1">Final Mileage</p>
                  <p className="font-euclid text-base font-bold">
                    {bookingDetails?.finalMileage || 0} miles
                  </p>
                </Col>
              </>
            )}
          </Row>
        </div>

        {/* Invoice Details - Invoice Style */}
        {/* Initial Booking Charges */}
        <div className="mb-4">
          <h4 className="font-tavi text-lg text-black font-semibold mb-3">
            Initial Booking Charges
          </h4>
          <Table
            bordered
            className="invoice-table"
            style={{ marginBottom: "20px" }}
          >
            <tbody>
              <tr>
                <th style={{ backgroundColor: "#f5f5f5" }}>
                  {bookingDetails?.dropoffLocation
                    ? `Distance Rate ($${getHourlyRate() || 0}/hr)`
                    : `Hourly Rate ($${getHourlyRate() || 0}/hr)`}
                </th>
                <td style={{ textAlign: "right" }}>
                  $
                  {(
                    (getHourlyRate() || 0) *
                    ((bookingDetails?.duration || 0) / 60)
                  ).toFixed(2)}
                </td>
              </tr>

              <tr>
                <th style={{ backgroundColor: "#f5f5f5" }}>
                  {`Mileage Fee (${bookingDetails?.serviceType} Luxury) ($${getPerMileRate() || 0}/mile)`}
                </th>
                <td style={{ textAlign: "right" }}>
                  ${((bookingDetails?.initialMileage || 0) * (getPerMileRate() || 0)).toFixed(2)}
                </td>
              </tr>

              <tr style={{ backgroundColor: "#e8f5e9", fontWeight: "bold" }}>
                <th style={{ backgroundColor: "#c8e6c9", fontSize: "14px" }}>
                  Initial Charge
                </th>
                <td style={{ fontSize: "14px", textAlign: "right" }}>
                  ${(bookingDetails?.initialCharges || 0).toFixed(2)}
                </td>
              </tr>
            </tbody>
          </Table>
        </div>

        {/* Additional Charges (if completed) */}
        {bookingDetails?.status === "COMPLETED" && (
          <div className="mb-4">
            <h4 className="font-tavi text-lg text-black font-semibold mb-3">
              Additional Charges (Upon Completion)
            </h4>
            <Table
              bordered
              className="invoice-table"
              style={{ marginBottom: "20px" }}
            >
              <tbody>
                {(bookingDetails?.finalDuration || 0) > (bookingDetails?.duration || 0) && (
                  <tr>
                    <th style={{ backgroundColor: "#f5f5f5" }}>
                      {bookingDetails?.dropoffLocation
                        ? `Additional Distance Rate ($${getHourlyRate() || 0}/hr)`
                        : `Additional Hourly Rate ($${getHourlyRate() || 0}/hr)`}
                    </th>
                    <td style={{ textAlign: "right" }}>
                      $
                      {(
                        (getHourlyRate() || 0) *
                        (((bookingDetails?.finalDuration || 0) - (bookingDetails?.duration || 0)) / 60)
                      ).toFixed(2)}
                    </td>
                  </tr>
                )}

                {(bookingDetails?.finalMileage || 0) > (bookingDetails?.initialMileage || 0) && (
                  <tr>
                    <th style={{ backgroundColor: "#f5f5f5" }}>
                      {`Additional Mileage Fee (${bookingDetails?.serviceType} Luxury) ($${getPerMileRate() || 0}/mile)`}
                    </th>
                    <td style={{ textAlign: "right" }}>
                      ${(((bookingDetails?.finalMileage || 0) - (bookingDetails?.initialMileage || 0)) * (getPerMileRate() || 0)).toFixed(2)}
                    </td>
                  </tr>
                )}

                <tr>
                  <th style={{ backgroundColor: "#f5f5f5" }}>Booking Fee</th>
                  <td style={{ textAlign: "right" }}>${getBookingFee()}</td>
                </tr>

                <tr>
                  <th style={{ backgroundColor: "#f5f5f5" }}>Service Fee</th>
                  <td style={{ textAlign: "right" }}>${getServiceFee()}</td>
                </tr>

                <tr>
                  <th style={{ backgroundColor: "#f5f5f5" }}>Gratuity</th>
                  <td style={{ textAlign: "right" }}>
                    ${(bookingDetails?.gratuityAmount || 0).toFixed(2)}
                  </td>
                </tr>

                <tr>
                  <th style={{ backgroundColor: "#f5f5f5" }}>Tolls Charges</th>
                  <td style={{ textAlign: "right" }}>${bookingDetails?.tolls ? bookingDetails?.tolls : 0}</td>
                </tr>

                <tr style={{ backgroundColor: "#e8f5e9", fontWeight: "bold" }}>
                  <th style={{ backgroundColor: "#c8e6c9", fontSize: "14px" }}>
                    Additional Charge
                  </th>
                  <td style={{ fontSize: "14px", textAlign: "right" }}>
                    ${((bookingDetails?.totalCharges || 0) - (bookingDetails?.initialCharges || 0)).toFixed(2)}
                  </td>
                </tr>
              </tbody>
            </Table>
          </div>
        )}

        {/* Total Amount */}
        <Table
          bordered
          className="invoice-table"
          style={{ marginBottom: "20px" }}
        >
          <tbody>
            <tr style={{ backgroundColor: "#e8f5e9", fontWeight: "bold" }}>
              <th style={{ backgroundColor: "#c8e6c9", fontSize: "16px" }}>
                Total Amount
              </th>
              <td style={{ fontSize: "16px", textAlign: "right" }}>
                ${(bookingDetails?.totalCharges || 0).toFixed(2)}
              </td>
            </tr>
          </tbody>
        </Table>
      </div>
    </Modal>

    {/* Assign Chauffeur Modal */}
    <Modal
      title={
        <h3 className="font-tavi text-2xl text-black">
          Assign Chauffeur
        </h3>
      }
      open={assignChauffeurModalVisible}
      onCancel={() => {
        setAssignChauffeurModalVisible(false);
        form.resetFields();
      }}
      afterOpenChange={(open) => {
        // Fetch chauffeurs when modal opens
        if (open && bookingDetails?.serviceType) {
          console.log("🔄 Modal opened, fetching chauffeurs...");
          getChauffeursByService();
        }
      }}
      footer={null}
      width={600}
    >
      <Form
        form={form}
        name="assignChauffeur"
        layout="vertical"
        onFinish={handleAssignChauffeur}
        onFinishFailed={(errorInfo) => {
          console.log("Failed:", errorInfo);
        }}
      >
        <Form.Item
          name="selectedChauffeur"
          label={
            <p className="font-euclid text-sm text-[#34324B] font-bold">
              Select Chauffeur to Assign
            </p>
          }
          rules={[
            {
              required: true,
              message: "Please select a chauffeur!",
            },
          ]}
        >
          <Select
            placeholder="Select Chauffeur"
            className="h-12 text-sm font-euclid bg-gray-100 max-sm:text-xs"
            suffixIcon={<TiArrowSortedDown />}
            options={chauffeurs
              .filter((item) => item?.chauffeur) // Filter out items without chauffeur
              .map((item) => {
                const chauffeur = item?.chauffeur;
                const name = `${chauffeur?.firstName || ''} ${chauffeur?.lastName || ''}`.trim();
                const id = chauffeur?._id;
                console.log("🔧 Mapping chauffeur:", { name, id, item });
                return {
                  label: (
                    <span className="font-euclid text-sm text-black">
                      {name || 'Unknown Chauffeur'}
                    </span>
                  ),
                  value: id,
                };
              })}
            notFoundContent={
              chauffeurs.length === 0 ? (
                <div className="text-center p-2">No chauffeurs available for this service type</div>
              ) : (
                <div className="text-center p-2">No valid chauffeurs found</div>
              )
            }
          />
        </Form.Item>

        <div className="flex justify-end gap-3 mt-6">
          <Button
            onClick={() => {
              setAssignChauffeurModalVisible(false);
              form.resetFields();
            }}
            className="font-euclid"
          >
            Cancel
          </Button>
          <Button
            type="primary"
            htmlType="submit"
            loading={assignLoading}
            className="bg-button text-black border-none font-bold font-euclid hover:bg-button"
          >
            Assign Chauffeur
          </Button>
        </div>
      </Form>
    </Modal>
    </>
  );
};

export default ReportDetails;
